import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isTestEnvironment } from '@api-config';

declare var gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  private router = inject(Router);

  private googleAnalyticsId = 'G-TFYFNYZ1XS';

  /** Счётчики работают только на проде: локально и на dev/test стендах статистику не собираем */
  private enabled = false;

  public initialize() {
    if (isTestEnvironment()) {
      return;
    }
    this.enabled = true;

    this.onRouteChange();
    this.addYandexMetrica();
    // dynamically add analytics scripts to document head
    try {
      const url = 'https://www.googletagmanager.com/gtag/js?id=';
      const gTagScript = document.createElement('script');
      gTagScript.async = true;
      gTagScript.src = `${url}${this.googleAnalyticsId}`;
      document.head.appendChild(gTagScript);

      const dataLayerScript = document.createElement('script');
      dataLayerScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${this.googleAnalyticsId}', {'send_page_view': false});`;
      document.head.appendChild(dataLayerScript);
    } catch (e) {
      console.error('Error adding Google Analytics', e);
    }
  }

  // track visited routes
  private onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', this.googleAnalyticsId, {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }

  // use gtag.js to send Google Analytics Events
  public event(action: string, eventCategory?: string, eventLabel?: string) {
    if (!this.enabled) {
      return;
    }

    gtag('event', action, {
      ...(eventCategory && { event_category: eventCategory }),
      ...(eventLabel && { event_label: eventLabel }),
    });
  }


  trackIntentionAgreementCreation(employerRegion: string): void {
    if (!this.enabled) {
      return;
    }

    try {
      gtag('event', 'intention_agreement_creation', {
        event_category: employerRegion,
      });
    } catch (e) {
      console.error('GA tracking error', e);
    }
  }



  addYandexMetrica(): void {
    // Check if the script is already added to avoid duplicates
    if (document.querySelector(`script[src='https://mc.yandex.ru/metrika/tag.js']`)) {
      return;
    }

    // Create and append the Yandex Metrica script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.text = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        k=e.createElement(t), a=e.getElementsByTagName(t)[0], k.async=1, k.src=r, a.parentNode.insertBefore(k,a)
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

      ym(98112679, 'init', {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true
      });
    `;
    document.head.appendChild(script);

    // Add the noscript tag with the tracking image for users with JavaScript disabled
    const noScript = document.createElement('noscript');
    const img = document.createElement('img');
    img.src = 'https://mc.yandex.ru/watch/98112679';
    img.alt = '';
    img.style.position = 'absolute';
    img.style.left = '-9999px';
    noScript.appendChild(img);
    document.body.appendChild(noScript);
  }
}
